/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Department_Members_TabInputs */

const en_department_members_tab = /** @type {(inputs: Department_Members_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const nl_department_members_tab = /** @type {(inputs: Department_Members_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leden`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Department_Members_TabInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const department_members_tab = /** @type {((inputs?: Department_Members_TabInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Department_Members_TabInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_department_members_tab(inputs)
	return en_department_members_tab(inputs)
});